import React, { useState, useEffect, useMemo } from "react";
import _, { assign, set } from "lodash";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReviewList from "../components/common/reviewComponents/reviewList";
import { fetchReviews, reviewsSelector } from "../../store/slices/reviews";
import { createFilter } from "react-search-input";
import { useSelector, useDispatch } from "react-redux";
import {
  TextField,
  MenuItem,
  Typography,
  Grid,
  Box,
  Button,
  Tabs,
  Tab,
} from "@mui/material";
import { TopicChip as Chip, TopicChip } from "../components/common/topicChip";
import CustomizeResponse from "../components/common/reviewComponents/customizeResponse";
import moment from "moment";
import {
  fetchGPTUsageData,
  logSelector,
  setInput,
} from "../../store/slices/logs";
import AppConfig from "../../appConfig";
import PromptText from "../components/common/promptComponents/promptText";
import PromptList from "../components/common/promptComponents/promptList";
import PromptDetail from "../components/common/promptComponents/promptDetail";
import {
  fetchprompts,
  promptsSelector,
  triggerCopyPrompt,
  triggerDeletePrompt,
  assignPromptToProcess,
  setSelectedPromptData,
  deleteCompanyPromptProcess,
  fetchPromptEnvAssignments,
} from "../../store/slices/prompts";
import KeywordHelp from "../components/common/promptComponents/keywordHelp";
import PromptReport from "../components/common/promptComponents/promptReport";
import { locationsSelector } from "../../store/slices/location";
import { convertArrayToDictionary, defaultGuid, hasLowReasoningEffortFloor } from "../../common/utils";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SvgIcon from "@mui/material/SvgIcon";
import { isValidJSON } from "../components/common/reviewComponents/reviewUtils";
import { use } from "react";
 
const initialCache = {};
const assignPromptType = [
  "Sentiments",
  "Response",
  "Business",
  "Review Request Email",
  "Review Request SMS",
  "Review Request",
  "Phrase Summary",
  "Agent",
  "Report"
];
const Prompts = ({
  selectedCompany,
  selectedLocation,
  userRoles,
  setSelectedLocation,
  locations,
  isIRUser,
  startDate,
  endDate,
  selectedEnv
}) => {
  const [text, setText] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedExampleReviews, setSelectedExampleReviews] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState({});
  const [isNew, setIsNew] = useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [scope, setScope] = useState("Global");
  const [promptOutput, setPromptOutput] = useState("");
  const [seed, setSeed] = useState("None");
  const [selectedReviewIds, setSelectedReviewIds] = useState([]);
  const [selectedReviewText, setSelectedReviewText] = useState([]);
  const [selectedReviewAuthor, setSelectedReviewAuthor] = useState([]);
  const { reviews } = useSelector(reviewsSelector);
  const { gptUsage } = useSelector(logSelector);
  const { generateResponse } = useSelector(reviewsSelector);
  const { prompts } = useSelector(locationsSelector);
  const [customSettings, setCustomsettings] = useState({
    executeParallel: true,
    singleReview: false,
  });
  const [isMultiple, setIsMultiple] = useState(false);
  const [selectedOption, setSelectedOption] = useState("With Text");
  const [refresh, setRefresh] = useState(false);
  const [noOfPages, setPages] = useState(0);
  const [name, setName] = useState("");
  const [type, setType] = useState("Sentiments");
  const [llm, setLlm] = useState("gpt-4");
  const [cached, setCached] = useState(false);
  const [api, setApi] = useState("completions");
  const [version, setVersion] = React.useState(null);
  const [subType, setSubType] = React.useState(null);
  const [reviewType, setReviewType] = useState("None");
  const [passReviews, setPassReviews] = useState(true);
  const [description, setDescription] = useState("");
  const [verbosity, setVerbosity] = useState("medium");
  const [reasoningEffort, setReasoningEffort] = useState("medium");
  const [temperature, setTemperature] = useState(0);
  const [inputFactor, setInputFactor] = useState(40);
  const [jsonResponse, setJsonResponse] = useState(false);
  const [jsonResponseSchemValue, setJsonResponseSchemaValue] = useState(null);
  const [web_search, setWeb_search] = useState(false);
  const [jsonResponseSchema, setJsonResponseSchema] = useState(false);
  const [deepResearch, setDeepResearch] = useState(false);
  const [topP, setTopP] = useState(1);
  const [presencePenalty, setPresencePenalty] = useState(0);
  const [maxLength, setMaxLength] = useState(500);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0);
  const [promptText, setPromptText] = useState("");
  const [systemPrompt, setSystemPrompt] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAssignModal, setOpenAssignModal] = useState(false);
  const {selectedPromptData} = useSelector(promptsSelector)
  const [companyPromptData, setCompanyPromptData] = useState({});
  const [nextPromptId, setNextPromptId] = useState(null);

  //prompt ids for testing run prompt
  
  const handleClickOpen = () => {
    setOpenDeleteModal(true);
  };
  const handleAssignClickOpen = () => {
    setOpenAssignModal(true);
  };
 
  const handleClose = () => {
    setOpenDeleteModal(false);
    setCompanyPromptData((prev) => ({ ...prev, delete: false }));
  };
  const handleAssignClose = () => {
    setOpenAssignModal(false);
    setCompanyPromptData((prev) => ({ ...prev, assign: false }));
  };
  const getProcess = (promptType) => {
    switch (promptType) {
      case "Sentiments":
        return { process: "ProcessReviewsForTopics", step: "TopicSentiment" };
      case "Response":
        return { process: "GenerateResponse", step: "GenerateResponse" };
      case "Business":
        return {
          process: "Business",
          step: "Business",
        };
        case "Review Request":
        return {
          process: "GenerateRequestText",
          step: "GenerateRequestText",
        };
      case "Review Request Email":
        return {
          process: "GenerateRequestText",
          step: "GenerateRequestTextForEmail",
        };
      case "Review Request SMS":
        return {
          process: "GenerateRequestText",
          step: "GenerateRequestTextForSMS",
        };
      case "Phrase Summary":
        return { process: "PhraseSummary", step: "PhraseSummary" };
      case "Agent":
        return { process: "ReviewAgent", step: "ReviewAgent" };
      default:
        return null;
    }
  };
  const handleDelete = () => {
    
    if(companyPromptData?.remove) {
      setCompanyPromptData((prev)=>({...prev, assign:false}));
      dispatch(setSelectedPromptData({...selectedPrompt, assignCompanyId: null}));
      var process = getProcess(selectedPrompt?.type);
      dispatch(deleteCompanyPromptProcess({processName: process?.process,  subType: selectedPrompt?.subType, selectedCompanyId: selectedCompany}, true));
    }else{
        dispatch(triggerDeletePrompt(selectedPrompt?.promptId, selectedCompany));
    }
    setSelectedPrompt({});
    setRefresh(!refresh);
    setOpenDeleteModal(false);
    setCompanyPromptData((prev) => ({ ...prev, remove: false }));
  };
  const handleAssignPrompt = () => {
    const prompt = _.find(prompts, { promptId: selectedPrompt?.promptId });
    const process = getProcess(prompt?.type, prompt?.subType);
    const data = {
      companyId: companyPromptData?.assign ? selectedCompany : defaultGuid,
      processName: process?.process,
      step: process?.step,
      promptId: selectedPrompt?.promptId,
      subType: selectedPrompt?.subType,
      selectedCompanyId: selectedCompany,
    };
    if (process) {
      dispatch(assignPromptToProcess(data, true));
      dispatch(setSelectedPromptData({...selectedPrompt, assignCompanyId: selectedCompany}));
    }
 
    setOpenAssignModal(false);
    setSelectedPrompt({});
    setRefresh(!refresh);
  };
  const handleCopy = () => {
    if (selectedPrompt?.promptId) {
      dispatch(triggerCopyPrompt(selectedPrompt?.promptId, selectedCompany,selectedEnv));
    }
  };
  useEffect(() => {
    if (isNew) {
      setSelectedPrompt({});
    }
  }, [isNew]);
  useEffect(
    () => setSelectedReviewIds([]),
    [selectedLocation, selectedCompany]
  );
 
  useEffect(() => {
    setText(generateResponse);
  }, [generateResponse]);
 
  useEffect(() => {
    setText("");
  }, [selectedReviewIds]);
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const getSortedReviews = () => {
    if (reviews && reviews.length > 0) {
      return _.sortBy(_.cloneDeep(reviews), ["reviewDateTime"], ["desc"]);
    } else {
      return [];
    }
  };
  const handleLocationChange = (event) => {
    const locationId = event.target.value;
    const selectedLocation = locations.find(
      (location) => location.locationId === locationId
    );
    setSelectedLocation(locationId);
    handleCloseUserMenu();
  };
  const sortedReviews = React.useMemo(
    () => getSortedReviews(),
    [reviews, startDate, endDate]
  );
 
  const dispatch = useDispatch();
 
  const handleCheckboxChange = (reviewId, reviewText) => {
    if (isMultiple) {
      if (selectedReviewIds.includes(reviewId)) {
        setSelectedReviewIds(selectedReviewIds.filter((id) => id !== reviewId));
        setSelectedReviewText(
          selectedReviewText.filter((text) => text !== reviewText)
        );
      } else {
        setSelectedReviewIds([...selectedReviewIds, reviewId]);
        setSelectedReviewText([...selectedReviewText, reviewText]);
      }
    } else {
      if (selectedReviewIds.includes(reviewId)) {
        setSelectedReviewIds(selectedReviewIds.filter((id) => id !== reviewId));
        setSelectedReviewText(
          selectedReviewText.filter((text) => text !== reviewText)
        );
      } else {
        setSelectedReviewIds([reviewId]);
        setSelectedReviewText([reviewText]);
      }
      setSelectedExampleReviews([]);
    }
  };
 
  useEffect(() => {
    setSearchTerm("");
    setSelectedExampleReviews([]);
  }, [selectedLocation, startDate, endDate, sortedReviews]);
 
  useEffect(() => {
    if (selectedCompany) {
      dispatch(setInput({}));
    }
  }, [selectedCompany]);
  useEffect(() => {
    dispatch(fetchPromptEnvAssignments());
  }, [dispatch, selectedEnv]);
  useEffect(() => {
    dispatch(
      setInput({
        PromptId: selectedPrompt?.promptId,
        Client: AppConfig.appMode,
      })
    );
  }, [selectedPrompt]);
  const bindTopics = (review) => {
    return _.map(review?.topics, (a, index) =>
      a.topic !== "" ? (
        <TopicChip
          sx={{ ml: 2 }}
          className={
            a?.sentiment === "Positive" ? "positive-chip" : "negative-chip"
          }
          key={index}
          //  color={a?.sentiment == "Positive" ? "success" : "error"}
          label={a?.topic}
        />
      ) : (
        ""
      )
    );
  };
 
  const bindfinalData = (data) => {
    return _.map(_.cloneDeep(data), (it, index) => {
      const topicData = _.map(it?.topicData?.split("|"), (ob) => {
        const [topic, sentiment] = ob?.split(":");
        return { topic, sentiment };
      });
      it["topics"] = topicData;
      it["topicElement"] = bindTopics(it);
      return it;
    });
  };
  const KEYS_TO_FILTERS = ["responseText", "reviewText", "author"];
  const prepareFinalData = (data) => {
    let cloneData = bindfinalData(data);
    let filterData = cloneData;
    switch (selectedOption) {
      case "With Text":
        filterData = _.filter(filterData, (a) => a.reviewText != null);
        break;
      case "Without Text":
        filterData = _.filter(filterData, (a) => a.reviewText == null);
        break;
      case "With Response":
        filterData = _.filter(filterData, (a) => a.responseText != null);
        break;
      case "Without Response":
        filterData = _.filter(filterData, (a) => a.responseText == null);
        break;
    }
    if (selectedLocation != "all") {
      filterData = _.filter(
        filterData,
        (a) => a.locationId == selectedLocation
      );
    }
    if (searchTerm) {
      filterData = filterData.filter(createFilter(searchTerm, KEYS_TO_FILTERS));
    }
 
    return _.orderBy(filterData, "reviewDateTime", "desc");
  };
 
  const reveiwsMemo = useMemo(()=>convertArrayToDictionary(reviews, 'reviewId'),[reviews]);
  const selectedReview = useMemo(()=>{
    return _.filter(reveiwsMemo, (it)=>_.includes(selectedReviewIds, it.reviewId));
  }, [selectedReviewIds]);

  
  const finalData = React.useMemo(
    () => prepareFinalData(sortedReviews),
    [sortedReviews, selectedOption, selectedLocation, searchTerm]
  );
  //======Pagination======//
  const itemsPerPage = useMemo(() => 50, []);
 
  useEffect(() => {
    setPages(Math.ceil(finalData?.length / itemsPerPage));
  }, [finalData]);
 
  //===Pagination end====//
 
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  // Selects the prompt the same way a click in the prompt list does, then shows it on Manage Prompts.
  const handleOpenPromptFromReport = (prompt) => {
    dispatch(setSelectedPromptData(prompt));
    setIsNew(false);
    setSelectedPrompt(prompt);
    setSelectedTab(0);
  };
  const CustomIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* Custom SVG path */}
      <path d="M12 4V1L8 5l4 4V6c2.21 0 4 1.79 4 4s-1.79 4-4 4v3l4 4 4-4-4-4v-3c0-3.87-3.13-7-7-7zm-1 5h2v4h-2v-4z" />
      {/* Text element in the SVG */}
      <text
        x="50%"
        y="50%"
        alignmentBaseline="middle"
        textAnchor="middle"
        fontSize="8"
        fill="currentColor"
      ></text>
    </SvgIcon>
  );
 
  //  useEffect(()=>{
  //   const defaultParameters = isValidJSON(selectedPrompt?.defaultParameters) ? JSON.parse(selectedPrompt?.defaultParameters) : {};
  //   if( isNew){
  //    if((llm==="gpt-5.1" || llm==="gpt-5.2")){
  //       setReasoningEffort('none')
  //    }else if(llm==="gpt-5-mini"){
  //       setReasoningEffort("minimal")
  //    }else{
  //       setReasoningEffort("medium");
  //    }

  //     if(selectedPrompt?.promptId&& (llm==="gpt-5.1" || llm==="gpt-5.2")){
  //       setReasoningEffort('none')
  //   }else if(llm==="gpt-5-mini"){
  //     setReasoningEffort("minimal")
  //   }
  //   }
   
  //  },[llm, isNew, selectedPrompt])
  
  //  useEffect(()=>{
  //   if(((llm==="gpt-5.1" || llm==="gpt-5.2" || _.includes(llm, `gpt-5.4`)) && reasoningEffort ==='minimal')){
  //     setReasoningEffort('none');
  //   }
  //   else if(!(llm==="gpt-5.1" || llm==="gpt-5.2" || _.includes(llm, `gpt-5.4`)) && reasoningEffort ==='none'){
  //       setReasoningEffort('minimal');
  //   }
  //  }, [llm])
   const handleLLMChange = (e) => {
    const selectedLLM = e.target.value;
    setLlm(selectedLLM);
      if(hasLowReasoningEffortFloor(selectedLLM)){
        setReasoningEffort('low')
    }else if((selectedLLM==="gpt-5.1" || selectedLLM==="gpt-5.2" || _.includes(selectedLLM, `gpt-5.4`) || _.includes(selectedLLM, `gpt-5.6`) || _.includes(selectedLLM, `gpt-6`))){
        setReasoningEffort('none')
    }else if(selectedLLM==="gpt-5-mini"){
      setReasoningEffort("minimal")
    }else{
      setReasoningEffort("medium");
    }
  }
  
  return (
    <>
      <Box sx={{ height: '100%', margin: '0 -24px 0 -12px'}}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          sx={{ borderBottom: "1px solid #888", pt: 0.5 }}
        >
          <Tab
            value={0}
            sx={{ textTransform: "none" }}
            label="Manage Prompts"
          />
          <Tab value={1} sx={{ textTransform: "none" }} label="Test Prompt" />
          {
            <Tab
              value={2}
              sx={{ textTransform: "none" }}
              label="Keywords Help"
            />
          }
          <Tab value={3} sx={{ textTransform: "none" }} label="Prompt Report" />
        </Tabs>
        {(selectedTab === 0 || selectedTab === 1) && (
          <>
            <Grid container sx={{ height: 'calc(100% - 54px)', display: 'flex', flexWrap: 'nowrap' }}>
              <Grid
                item
                sx={{
                  borderRight: (theme) => `1px solid ${theme.palette.divider}`,
                  width: '25%',
                  minWidth: '400px',
                  maxWidth: '500px',
                  flexShrink: 0,
                }}
              >
                {selectedTab === 1 && (
                  <ReviewList
                    data={sortedReviews}
                    startDate={startDate}
                    endDate={endDate}
                    selectedCompany={selectedCompany}
                    selectedLocation={selectedLocation}
                    singleSelectFunction={handleCheckboxChange}
                    isPrompt={true}
                    selectedReviewIds={selectedReviewIds}
                    isMultiple={isMultiple}
                    setSelectedReviewIds={setSelectedReviewIds}
                    setSelectedReviewText={setSelectedReviewText}
                    selectedReviewText={selectedReviewText}
                    reviewHeight={242}
                  />
                )}
                {selectedTab === 0 && (
                  <PromptList
                    scope={scope}
                    setScope={setScope}
                    data={prompts}
                    setSelectedPrompt={setSelectedPrompt}
                    setIsNew={setIsNew}
                    selectedPrompt={selectedPrompt}
                    height={105}
                    selectedCompany={selectedCompany}
                  />
                )}
              </Grid>
 
              <Grid
                item
                //  className={`grid-item ${expanded ? 'expand' : ''}`}
                sx={{
                  borderRight: (theme) => `1px solid ${theme.palette.divider}`,
                  flexGrow: 1,
                  display: expanded ? 'flex' : 'flex',
                  minWidth: '420px',
                  paddingLeft: '15px',
                }}
              >
                <div style={{ width: '100%' }}>
                  <div>
                    <div>
                      <div>
                        {selectedTab === 1 && (
                          <CustomizeResponse
                            selectedCompany={selectedCompany}
                            selectedReviewText={selectedReviewText}
                            selectedReviewIds={selectedReviewIds}
                            setRefresh={setRefresh}
                            refresh={refresh}
                            gptUsage={gptUsage}
                            selectedId={selectedId}
                            setSelectedId={setSelectedId}
                            text={text}
                            setText={setText}
                            customSettings={customSettings}
                            setCustomsettings={setCustomsettings}
                            promptOutput={promptOutput}
                            setPromptOutput={setPromptOutput}
                            isPrompt={true}
                            setIsMultiple={setIsMultiple}
                            isMultiple={isMultiple}
                            setSelectedReviewIds={setSelectedReviewIds}
                            setSelectedReviewText={setSelectedReviewText}
                            selectededReview={selectedReview}
                            boxHeight={150}
                            setPromptTab={setSelectedTab}
                          />
                        )}
                        {selectedTab === 0 && (
                          <div>
                            <PromptText
                              prompt={selectedPrompt}
                              promptText={promptText}
                              isManage={true}
                              setPromptText={setPromptText}
                              handleClickOpen={handleClickOpen}
                              openDeleteModal={openDeleteModal}
                              handleClose={handleClose}
                              handleDelete={handleDelete}
                              promptId={selectedPrompt?.promptId}
                              jsonResponseSchema={jsonResponseSchema}
                              setJsonResponseSchemaValue={
                                setJsonResponseSchemaValue
                              }
                              jsonResponseSchemValue={jsonResponseSchemValue}
                              systemPrompt={systemPrompt}
                              setSystemPrompt={setSystemPrompt}
                              // Expand/collapse props
                              expanded={expanded}
                              setExpanded={setExpanded}
                              ArrowBackIcon={ArrowBackIcon}
                              ArrowForwardIcon={ArrowForwardIcon}
                              isNew={isNew}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>

              <Grid
                item
                //  className={`grid-item ${expanded ? 'shrink' : ''}`
                sx={{
                  // borderRight: (theme) => `1px solid ${theme.palette.divider}`,
                  display: expanded ? "none" : "block",
                  width: selectedTab === 1 ? '33%' : '500px', 
                  flexShrink: 0,
                }}
              >
                <div>
                  <div>
                    <div>
                      <div
                        style={{ paddingLeft: "15px" }}
                      >
                        {selectedTab === 1 && (
                          <PromptText output={promptOutput} />
                        )}                        
                        {selectedTab === 0 && (
                          <div className="">
                            <PromptDetail
                              scope={scope}
                              data={selectedPrompt}
                              isNew={isNew}
                              setIsNew={setIsNew}
                              setName={setName}
                              name={name}
                              type={type}
                              setType={setType}
                              seed={seed}
                              setSeed={setSeed}
                              llm={llm}
                              setLlm={setLlm}
                              handleLLMChange={handleLLMChange}
                              cached={cached}
                              setCached={setCached}
                              api={api}
                              setApi={setApi}
                              reviewType={reviewType}
                              setReviewType={setReviewType}
                              passReviews={passReviews}
                              setPassReviews={setPassReviews}
                              description={description}
                              setDescription={setDescription}
                              setVerbosity={setVerbosity}
                              verbosity={verbosity}
                              reasoning_effort={reasoningEffort}
                              setReasoningEffort={setReasoningEffort}
                              temperature={temperature}
                              setTemperature={setTemperature}
                              jsonResponse={jsonResponse}
                              setJsonResponse={setJsonResponse}
                              jsonResponseSchema={jsonResponseSchema}
                              setJsonResponseSchema={setJsonResponseSchema}
                              deepResearch={deepResearch}
                              setDeepResearch={setDeepResearch}
                              jsonResponseSchemValue={jsonResponseSchemValue}
                              setJsonResponseSchemaValue={
                                setJsonResponseSchemaValue
                              }
                              topP={topP}
                              setTopP={setTopP}
                              inputFactor={inputFactor}
                              setInputFactor={setInputFactor}
                              presencePenalty={presencePenalty}
                              setPresencePenalty={setPresencePenalty}
                              maxLength={maxLength}
                              setMaxLength={setMaxLength}
                              frequencyPenalty={frequencyPenalty}
                              setFrequencyPenalty={setFrequencyPenalty}
                              promptText={promptText}
                              setPromptText={setPromptText}
                              systemPrompt={systemPrompt}
                              setSystemPrompt={setSystemPrompt}
                              setRefresh={setRefresh}
                              refresh={refresh}
                              companyId={selectedCompany}
                              setSelectedPrompt={setSelectedPrompt}
                              promptId={selectedPrompt?.promptId}
                              handleClickOpen={handleClickOpen}
                              openDeleteModal={openDeleteModal}
                              version={version}
                              setSubType={setSubType}
                              setVersion={setVersion}
                              subType={subType}
                              handleClose={handleClose}
                              handleDelete={handleDelete}
                              handleAssignClickOpen={handleAssignClickOpen}
                              setCompanyPromptData={setCompanyPromptData}
                              companyPromptData={companyPromptData}
                              handleAssignPrompt={handleAssignPrompt}
                              isAssignPrompt={_.includes(
                                assignPromptType,
                                type
                              )}
                              handleAssignClose={handleAssignClose}
                              openAssignModal={openAssignModal}
                              handleCopy={handleCopy}
                              buttonText="Save"
                              nextPromptId={nextPromptId}
                              setNextPromptId={setNextPromptId}
                              web_search={web_search} setWeb_search={setWeb_search}
                              setSelectedTab={setSelectedTab}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
              
            </Grid>
          </>
        )}
        {selectedTab === 2 && <KeywordHelp />}
        {selectedTab === 3 && <PromptReport data={prompts} onOpenPrompt={handleOpenPromptFromReport} />}
      </Box>
    </>
  );
};
 
export default Prompts;
